import React, { Component } from "react";
import styled from "styled-components";
import CompleteCase from "../../../../../models/CompleteCase";
import CaseRepository from "../../../../../common/repository/CaseRepository";
import Result from "../../../../../common/repository/Result";
import { toast } from "../../../../common/Toast";
import Instruction from "../../../../../models/Instructions";
const Container = styled.div`
  padding: 4px 16px;

  background: white;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 4px;
`;

interface Props {
  caseModel: CompleteCase;
  model: Instruction;
  caseRepo: CaseRepository;
  updateModel?(c: CompleteCase): void;
}

interface State {
  loading: boolean;
}

class CaseReminderListItem extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      loading: false,
    };
  }
  // componentDidMount() {
  //   this.getCase(this.props.model);
  // }

  // getCase = (modal: any) => {
 
  // }

  onClose = () => {
    const { model, caseModel, caseRepo, updateModel } = this.props;
    this.setState({ loading: true }, async () => {
      const result = await caseRepo.closeReminder({
        case_id: caseModel.getId(),
        remainder_id: model.getId(),
      });

      if (result instanceof Result.Success) {
        this.setState({ loading: false }, () => {
          const c = result.data as CompleteCase;
          if (updateModel) updateModel(c);
        });
      } else {
        this.setState({ loading: false }, () => {
          const message = result.message || "Something went wrong";
          toast.error(message);
        });
      }
    });
  };

  render() {
    const { model } = this.props;
    return (
      // <h1>
      //   {model.getInstruction()}
      // </h1>
      <Container >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            marginBottom: 4,
            width: "80%"
          }}
        >
        </div>
        {/* Optional: show extra info below in small text */}
        <div style={{ marginTop: 6, fontSize: "12px", }}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>By: <b>{`${model.getBy().getName()} (${model.getBy().getRole().getTitle()})`}</b></div>
            <div>{model.getPostedOn()}</div>

          </div>
          <div style={{ marginTop: 6, fontSize: "12px" }}>Type: {model.getInstructionType()}</div>
          <div style={{ marginTop: 6, fontSize: "18px" }}> {model.getInstruction()}</div>
        </div>
      </Container>
    )

  }
}

export default CaseReminderListItem;
